import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CreateDisputePageRoutingModule } from './create-dispute-routing.module';

import { CreateDisputePage } from './create-dispute.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CreateDisputePageRoutingModule
  ],
  declarations: [CreateDisputePage]
})
export class CreateDisputePageModule {}
